<template>
  <Modal
    :title="$t('versions')"
    :confirm-label="$t('got_it')"
    no-cancel
    @confirm="$modal.close"
  >
    <div class="space-y-6">
      <div class="rounded-md border-2 border-pink-500 px-5 py-4 text-center text-sm font-medium text-supplement">
        https://inspires.to/s/<strong class="text-pink-500">unique</strong>/your-content-experience
      </div>
      <p>{{ $t("versions_learn_more_intro") }}</p>
      <div class="flex items-center space-x-6">
        <div>
          <Button
            icon="pencil"
            color="pink"
            :ui="{ base: 'p-0 h-10 w-10' }"
          />
        </div>
        <p>{{ $t("versions_learn_more_personalize") }}</p>
      </div>
    </div>
  </Modal>
</template>
